import React, { useState, useEffect } from 'react';
import {
    Drawer, Box, Typography, IconButton, TextField, Button, Grid, FormControl, InputLabel, Select, MenuItem, InputAdornment
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { updateMedicine } from './api';

const EditMedicineDrawer = ({ open, onClose, selectedMedicine, onMedicineUpdated }) => {
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        price: '',
        stock: '',
        uom: '',
        dosage: '',
        expiryDate: '',
        status: 'Active',
    });

    useEffect(() => {
        if (selectedMedicine) {
            setFormData({
                name: selectedMedicine.name || '',
                description: selectedMedicine.description || '',
                price: selectedMedicine.price || '',
                stock: selectedMedicine.stock || '',
                uom: selectedMedicine.uom || '',
                dosage: selectedMedicine.specifications?.dosage || '',
                expiryDate: selectedMedicine.specifications?.expiryDate?.slice(0, 10) || '',
                status: selectedMedicine.status || 'Active',
            });
        }
    }, [selectedMedicine]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        try {
            const {
                name,
                description,
                price,
                stock,
                uom,
                dosage,
                expiryDate,
                status
            } = formData;

            const updatedMedicine = {
                name,
                description,
                price: parseFloat(price),
                stock: parseInt(stock),
                uom,
                status,
                specifications: {
                    dosage,
                    expiryDate: expiryDate ? new Date(expiryDate).toISOString() : null
                }
            };

            const result = await updateMedicine(selectedMedicine._id, updatedMedicine);

            if (result) {
                if (typeof onMedicineUpdated === 'function') {
                    onMedicineUpdated(result); // ✅ Actualiza el estado en el padre
                }
                onClose(); // ✅ Cierra el drawer
            }
        } catch (error) {
            console.error('Error updating medicine:', error);
            alert('Error updating medicine');
        }
    };

    return (
        <Drawer anchor="right" open={open} onClose={onClose} sx={{ width: 900 }}>
            <Box sx={{ width: '900px', p: 3 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Edit Medicine</Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Name" name="name" value={formData.name} onChange={handleChange} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Description" name="description" value={formData.description} onChange={handleChange} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth label="Price" name="price" value={formData.price}
                            onChange={handleChange} type="number"
                            InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Stock" name="stock" value={formData.stock} onChange={handleChange} type="number" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel>UOM</InputLabel>
                            <Select label="UOM" name="uom" value={formData.uom} onChange={handleChange}>
                                <MenuItem value="Tablet">Tablet</MenuItem>
                                <MenuItem value="Capsule">Capsule</MenuItem>
                                <MenuItem value="Syrup">Syrup</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Dosage" name="dosage" value={formData.dosage} onChange={handleChange} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth label="Expiry Date" name="expiryDate" type="date"
                            value={formData.expiryDate} onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                </Grid>

                <Box display="flex" justifyContent="space-between" sx={{ mt: 3 }}>
                    <Button variant="outlined" onClick={onClose}>Close</Button>
                    <Button variant="contained" onClick={handleSave}>Save</Button>
                </Box>
            </Box>
        </Drawer>
    );
};

export default EditMedicineDrawer;
